type ManageFirmJurisdictionsExpandGlyphProps = {
  expanded: boolean;
};

export default function ManageFirmJurisdictionsExpandGlyph ({
  expanded,
}: ManageFirmJurisdictionsExpandGlyphProps): JSX.Element {
  const stroke = {
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round" as const,
  };

  return (
    <svg
      className="h-4 w-4 shrink-0"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      {expanded ? (
        <path d="M4 8h8" {...stroke} />
      ) : (
        <>
          <path d="M8 4v8" {...stroke} />
          <path d="M4 8h8" {...stroke} />
        </>
      )}
    </svg>
  );
}
